import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import React, { useState, useEffect } from "react";
import PeopleIcon from '@mui/icons-material/People';
import EmailIcon from '@mui/icons-material/Email';
import RedeemIcon from '@mui/icons-material/Redeem';
import LockIcon from '@mui/icons-material/Lock';
import SecretSantaPairsInfoSendApproveDialog from "../../../dialog/SecretSantaPairsInfoSendApproveDialog";
import SecretSantaPresentCollectionApproveDialog from "../../../dialog/SecretSantaPresentCollectionApproveDialog";
import { api } from "../../../../api/api";
import SecretSantaMakePairsApproveDialog from "../../../dialog/SecretSantaMakePairsApproveDialog";
import { useSnackbar } from "notistack";
import SecretSantaLockersInfoDialog from '../../../dialog/SecretSantaLockersInfoDialog';

export function AdminActionButtons({
                                     locationId,
                                     locationName,
                                     lockersSupported,
                                     santaState,
                                     setBackdropOpen,
                                     setRequestSantaState,
                                   }) {

  const [makePairsDialog, openMakePairsDialog] = useState(false);
  const [makePairsApprove, setMakePairsApprove] = useState(false);
  const [pairsInfoDialog, openPairsInfoDialog] = useState(false);
  const [pairsInfoApprove, setPairsInfoApprove] = useState(false);
  const [presentCollectionDialog, openPresentCollectionDialog] = useState(false);
  const [presentCollectionApprove, setPresentCollectionApprove] = useState(false);
  const [lockersDialogOpen, setLockersDialogOpen] = useState(false);
  const [lockersData, setLockersData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const snackBarAddMessage = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };


  useEffect(() => {
    if (makePairsApprove) {
      openMakePairsDialog(false)
      setBackdropOpen(true)
      api.secretSanta.makePairs(locationId)
        .then(() => {
          setMakePairsApprove(false)
          setRequestSantaState(true)
        })
        .catch((error) => {
          console.log(error)
          snackBarAddMessage(`Unable make secret santa pairs, please check your permissions and try again. Error: ${error.status}`, 'error');
        })
        .finally(() => {
          setBackdropOpen(false)
        });
    }
  }, [makePairsApprove]);

  useEffect(() => {
    if (pairsInfoApprove) {
      openPairsInfoDialog(false)
      setBackdropOpen(true)
      api.sender.sendSecretSantasPairs(locationId)
        .then(() => {
          setPairsInfoApprove(false)
          setRequestSantaState(true)
        })
        .catch((error) => {
          console.log(error)
          snackBarAddMessage(`Unable send secret santa pairs, please check your permissions and try again. Error: ${error.status}`, 'error');
        })
        .finally(() => {
          setBackdropOpen(false)
        });
    }
  }, [pairsInfoApprove]);

  useEffect(() => {
    if (presentCollectionApprove) {
      openPresentCollectionDialog(false)
      setBackdropOpen(true)
      api.sender.sendSecretSantasPresents(locationId)
        .then(() => {
          setPresentCollectionApprove(false)
          setRequestSantaState(true)
        })
        .catch((error) => {
          console.log(error)
          snackBarAddMessage(`Unable send secret santa collection, please check your permissions and try again. Error: ${error.status}`, 'error');
        })
        .finally(() => {
          setBackdropOpen(false)
        });
    }
  }, [presentCollectionApprove]);

  const handleOpenLockersInfo = () => {
    setBackdropOpen(true);
    api.secretSanta.getLockersInfoForLocation(locationId)
      .then((data) => {
        setLockersData(data ?? null);
        setLockersDialogOpen(true);
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar(`Unable to load lockers info. Error: ${error.status}`, { variant: 'error' });
      })
      .finally(() => setBackdropOpen(false));
  };

  return (
    <>
      <SecretSantaMakePairsApproveDialog
        locationName={locationName}
        component={'span'}
        open={makePairsDialog}
        handleClose={() => openMakePairsDialog(false)}
        handleApprove={() => setMakePairsApprove(true)}
      />
      <SecretSantaPairsInfoSendApproveDialog
        locationName={locationName}
        component={'span'}
        open={pairsInfoDialog}
        handleClose={() => openPairsInfoDialog(false)}
        handleApprove={() => setPairsInfoApprove(true)}
      />
      <SecretSantaPresentCollectionApproveDialog
        locationId={locationId}
        locationName={locationName}
        component={'span'}
        open={presentCollectionDialog}
        handleClose={() => openPresentCollectionDialog(false)}
        handleApprove={() => setPresentCollectionApprove(true)}
      />

      <SecretSantaLockersInfoDialog
        open={lockersDialogOpen}
        onClose={() => setLockersDialogOpen(false)}
        locationName={locationName}
        data={lockersData}
      />

      <Tooltip title="Make Secret Santa pairs">
        <IconButton
          onClick={() => openMakePairsDialog(true)}
          color="secondary"
          sx={{ mt: 3, ml: 1 }}
          disabled={santaState !== 1}
        >
          <PeopleIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Send pairs information">
        <IconButton
          onClick={() => openPairsInfoDialog(true)}
          color="secondary"
          sx={{ mt: 3, ml: 1 }}
          disabled={santaState !== 2}
        >
          <EmailIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Send present collection information">
        <IconButton
          onClick={() => openPresentCollectionDialog(true)}
          color="secondary"
          sx={{ mt: 3, ml: 1 }}
          disabled={santaState !== 3}
        >
          <RedeemIcon />
        </IconButton>
      </Tooltip>

      {lockersSupported &&
        <Tooltip title="Show lockers info">
          <IconButton
            onClick={handleOpenLockersInfo}
            color="secondary"
            sx={{ mt: 3, ml: 1 }}
            disabled={lockersSupported === false}
          >
            <LockIcon />
          </IconButton>
        </Tooltip>}

    </>
  );
}

